import React, { useContext, useEffect,useState } from 'react'
import { Link, useNavigate } from 'react-router-dom';
import GameContext from '../context/game/GameContext';

export default function Navbar() {
  const context = useContext(GameContext)
  const { getGame,isRunning,setIsRunning} = context
  const [time, setTime] = useState(0);
  useEffect(() => {
    let intervalId;
    if (isRunning) {
      // setting time from 0 to 1 every 10 milisecond using javascript setInterval method
      intervalId = setInterval(() => setTime(time + 1), 10);
    }
    return () => clearInterval(intervalId);
  }, [isRunning, time]);

  const hours = Math.floor(time / 360000);

  // Minutes calculation
  const minutes = Math.floor((time % 360000) / 6000);

  // Seconds calculation
  const seconds = Math.floor((time % 6000) / 100);

  // Milliseconds calculation
  const milliseconds = time % 100;
  
  if(document?.getElementById('timer')?.innerHTML)
  document.getElementById('timer').innerHTML= (hours<10?"0"+hours:hours) + ':' + (minutes<10?"0"+minutes:minutes) + ':' + (seconds<10?"0"+seconds:seconds) + ':' + (milliseconds<10?"0"+milliseconds:milliseconds)
  const handelClick = () => {
    setTime(0)
    if (document.getElementById('defaultModal').classList.contains('hidden')) {
      document.getElementById('defaultModal').classList.remove('hidden')
      document.getElementById('defaultModal').classList.add('flex')
    }
    else {
      document.getElementById('defaultModal').classList.add('hidden')
      document.getElementById('defaultModal').classList.remove('flex')
    }
  }
  const handelSubmit = (e) => {
    e.preventDefault()
    const level = document.querySelector('input[name="level"]:checked').value;
    let k = 0
    if (level === 'Easy')
      k = Math.floor(Math.random() * 10 + 30);
    else if (level === 'Medium')
      k = Math.floor(Math.random() * 10 + 40);
    if (level === 'Hard')
      k = Math.floor(Math.random() * 14 + 50);
    getGame(k)
    handelClick()
    setIsRunning(true)
  }
  

  const navigate = useNavigate()
  const handelLogout = () => {
    localStorage.removeItem('token')
    localStorage.removeItem('username')
    localStorage.removeItem('userid')
    localStorage.removeItem('email')
    localStorage.removeItem('gameid')
    navigate("/login")
  }
  return (
    <>
      <nav className="flex flex-col justify-center items-center">
        <h1 className='bg-gradient-to-r from-red-900 to-black text-3xl md:text-5xl lg:text-9xl font-extrabold font-font-head bg-clip-text text-transparent'>Sudoku</h1>
        <div>
          <ul >
            <li className='hover:border-b border-red-900 text-xs md:text-xl font-bold md:font-extrabold bg-gradient-to-r from-red-900 to-black bg-clip-text text-transparent inline-block px-1 md:px-12 py-2'><Link to="/"><button onClick={handelClick}>New Game</button></Link></li>
            <li className='hover:border-b border-red-900 text-xs md:text-xl font-bold md:font-extrabold bg-gradient-to-r from-red-900 to-black bg-clip-text text-transparent inline-block px-1 md:px-12 py-2'><Link className='' to="/howtoplay">How To Play ?</Link></li>
            <li className='hover:border-b border-red-900 text-xs md:text-xl font-bold md:font-extrabold bg-gradient-to-r from-red-900 to-black bg-clip-text text-transparent inline-block px-1 md:px-12 py-2'><Link className='' to="/Dashboard">Dashboard</Link></li>
            {!localStorage.getItem('token') ?
              <li className='hover:border-b border-red-900 text-xs md:text-xl font-bold md:font-extrabold bg-gradient-to-r from-red-900 to-black bg-clip-text text-transparent inline-block px-1 md:px-12 py-2'><Link className='' to="/login">Login</Link></li> :
              <li className='hover:border-b border-red-900 text-xs md:text-xl font-bold md:font-extrabold bg-gradient-to-r from-red-900 to-black bg-clip-text text-transparent inline-block px-1 md:px-12 py-2'><button onClick={handelLogout}>LogOut</button></li>}
          </ul>
        </div>
      </nav>
      <div id="defaultModal" className="hidden overflow-y-auto overflow-x-hidden fixed top-32 right-0 left-0 z-50 w-full md:inset-0 md:h-full justify-center items-center">
        <div className="bg-black relative p-4 w-full max-w-2xl h-full md:h-auto">
          <div className="relative bg-white rounded-lg shadow">
            <div className="flex justify-between items-start p-4 rounded-t border-b">
              <h3 className="text-xl font-semibold text-gray-900">Level</h3>
              <button onClick={handelClick}><i className="text-xl hover:bg-gray-300 px-1 cursor-pointer rounded-md fa-solid fa-xmark"></i></button>
            </div>
            <div className="flex items-center p-6 space-x-2 rounded-b border-t border-gray-200">
              <form onSubmit={handelSubmit}>
                <span className='flex items-center text-lg font-serif font-bold'><input id='Easy' name='level' className='m-3' value='Easy' type="radio" /><label htmlFor="Easy">Easy</label> </span>
                <br />
                <span className='flex items-center text-lg font-serif font-bold'><input id='Medium' name='level' className='m-3' value='Medium' type="radio" /><label htmlFor="Medium">Medium</label> </span>
                <br />
                <span className='flex items-center text-lg font-serif font-bold'><input id='Hard' name='level' className='m-3' value="Hard" type="radio" /><label htmlFor="Hard">Hard</label> </span>
                <br />
                <button type="submit" className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800 disabled:cursor-not-allowed">Submit</button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
